export default {
	CLEAR_CACHE: 'CLEAR_CACHE'
};
